module.exports = __webpack_public_path__ + "static/assets/98987f457287d6ff172564e1221de459.png";